import { IConfigGlobal } from './config.global';

export enum ConfigEnv {
  LOCAL,
  DVLP,
  ACPT,
  PROD,
}

export interface Config extends IConfigGlobal {
  env: ConfigEnv;
  apiBasePath: string;
  authBaseUrl: string;
  showMissingTranslations: boolean;
  azureAppInsightsInstrumentationKey: string;
}
